import Vue from 'vue'
import Router from 'vue-router'
import auth from '../auth'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/views/Dashboard'
import Timeline from '@/views/Timeline'
// -- Rocket
import ConfigurationIndex from '@/views/rocket/configurations/Index'
import ConfigurationForm from '@/views/rocket/configurations/Form'
import WebhookIndex from '@/views/rocket/webhooks/Index'
import WebhookForm from '@/views/rocket/webhooks/Form'
// -- Mystique
import RealmIndex from '@/views/mystique/realms/Index'
import RealmForm from '@/views/mystique/realms/Form'
import GroupIndex from '@/views/mystique/groups/Index'
import GroupForm from '@/views/mystique/groups/Form'
import UserIndex from '@/views/mystique/users/Index'
import UserForm from '@/views/mystique/users/Form'
import AuditLogsIndex from '@/views/mystique/audit/Index'
// -- Cerebro
import EntityIndex from '@/views/cerebro/entities/Index'
import EntityForm from '@/views/cerebro/entities/Form'
import LinkIndex from '@/views/cerebro/links/Index'
// -- Beast
import WorkflowIndex from '@/views/beast/workflows/Index'
import WorkflowForm from '@/views/beast/workflows/Form'
import WorkflowVersions from '@/views/beast/workflows/Versions'
import WorkflowVersionsPreview from '@/views/beast/workflows/VersionsPreview'
import DecisionIndex from '@/views/beast/decisions/Index'
import DecisionForm from '@/views/beast/decisions/Form'
import DecisionVersions from '@/views/beast/decisions/Versions'
import DecisionVersionsPreview from '@/views/beast/decisions/VersionsPreview'

// -- SHAW
import ShawIndex from '@/views/shaw/events/Index'
import ShawForm from '@/views/shaw/events/Form'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'timeline',
          name: 'Timeline',
          component: Timeline
        },
        {
          path: 'rocket',
          name: 'Rocket',
          redirect: '/rocket/configurations',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'configurations',
              name: 'Configurações',
              component: ConfigurationIndex
            },
            {
              path: 'configuration/:id',
              name: 'Editar Configuração',
              component: ConfigurationForm
            },
            {
              path: 'configuration',
              name: 'Configuração',
              component: ConfigurationForm
            },
            {
              path: 'webhooks',
              name: 'Webhooks',
              component: WebhookIndex
            },
            {
              path: 'webhooks/new',
              name: 'Novo Webhook',
              component: WebhookForm
            },
            {
              path: 'webhooks/:id',
              name: 'Editar Webhook',
              component: WebhookForm
            }
          ]
        },
        {
          path: 'shaw',
          name: 'Shaw',
          redirect: '/shaw/events',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'events',
              name: 'Eventos',
              component: ShawIndex
            },
            {
              path: 'event/:name',
              name: 'Editar Evento',
              component: ShawForm
            },
            {
              path: 'event',
              name: 'Evento',
              component: ShawForm
            }
          ]
        },
        {
          path: 'cerebro',
          name: 'Cerebro',
          redirect: '/cerebro/entities',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'entities',
              name: 'Entidades',
              component: EntityIndex
            },
            {
              path: 'entities/new',
              name: 'Nova Entidade',
              component: EntityForm
            },
            {
              path: 'entities/:entity/:id',
              name: 'Editar Entidade',
              component: EntityForm
            },
            {
              path: 'links',
              name: 'Links',
              component: LinkIndex
            }
          ]
        },
        {
          path: '/mystique',
          name: 'Mystique',
          redirect: '/mystique/realms',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'realms',
              name: 'Realms',
              component: RealmIndex
            },
            {
              path: 'realms/new',
              name: 'Novo Realm',
              component: RealmForm
            },
            {
              path: 'realms/:id',
              name: 'Editar Realm',
              component: RealmForm
            },
            {
              path: 'groups',
              name: 'Grupos',
              component: GroupIndex
            },
            {
              path: 'groups/new',
              name: 'Novo Grupo',
              component: GroupForm
            },
            {
              path: 'groups/:id',
              name: 'Editar Grupo',
              component: GroupForm
            },
            {
              path: 'users',
              name: 'Usuários',
              component: UserIndex
            },
            {
              path: 'users/new',
              name: 'Novo Usuário',
              component: UserForm
            },
            {
              path: 'users/:id',
              name: 'Editar Usuário',
              component: UserForm
            },
            {
              path: 'audit',
              name: 'Auditoria',
              component: AuditLogsIndex
            }
          ]
        },
        {
          path: '/beast',
          name: 'Beast',
          redirect: '/beast/workflows',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'workflows',
              name: 'Workflows',
              component: WorkflowIndex
            },
            {
              path: 'workflows/new',
              name: 'Novo Workflow',
              component: WorkflowForm
            },
            {
              path: 'workflows/versions/:id',
              name: 'Versoes do Workflow',
              component: WorkflowVersions
            },
            {
              path: 'workflows/versions/:id/:versionId',
              name: 'Preview da Versao do Workflow',
              component: WorkflowVersionsPreview
            },
            {
              path: 'workflows/:id',
              name: 'Editar Workflow',
              component: WorkflowForm
            },
            {
              path: 'decisions',
              name: 'Decisions',
              component: DecisionIndex
            },
            {
              path: 'decisions/new',
              name: 'Nova Decision',
              component: DecisionForm
            },
            {
              path: 'decisions/:id',
              name: 'Editar Decision',
              component: DecisionForm
            },
            {
              path: 'decisions/versions/:id/:versionId',
              name: 'Preview da Versao do Decision',
              component: DecisionVersionsPreview
            },
            {
              path: 'decisions/versions/:id',
              name: 'Versoes da Decision',
              component: DecisionVersions
            }
          ]
        }
      ],
      beforeEnter: (to, from, next) => {
        auth.checkAuth()
        auth.login(next)
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js